module.exports = __webpack_public_path__ + "img/google-play.9bfd24fa.png";